import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import TabNavigation from "../../../components/TabNavigation/TabNavigation";
import { useMemo } from "react";

const navigationItemsInit = [
  { to: "/clients/:id/details", text: "ProfileDetails" },
  { to: "/clients/:id/reservations", text: "Reservations" },
  { to: "/clients/:id/open-gyms", text: "OpenGyms" },
  { to: "/clients/:id/gym-notifications", text: "GymNotifications" },
  { to: "/clients/:id/subscription-history", text: "SubscriptionHistory" },
];

const ClientLayout = () => {
  const location = useLocation();
  const { id = "" } = useParams();

  const navigationItems = useMemo(
    () =>
      navigationItemsInit.map((el) => ({
        ...el,
        to: el.to.replace(":id", id),
      })),
    [id]
  );

  if (location.pathname === `/clients/${id}`) {
    return <Navigate to={`/clients/${id}/details`} replace />;
  }

  return (
    <div>
      <TabNavigation items={navigationItems} />
      <div className={"page-content"}>
        <Outlet />
      </div>
    </div>
  );
};

export default ClientLayout;
